import { render, staticRenderFns } from "./VeteranDetail.vue?vue&type=template&id=6558d082&scoped=true&"
import script from "./VeteranDetail.vue?vue&type=script&lang=js&"
export * from "./VeteranDetail.vue?vue&type=script&lang=js&"
import style0 from "./VeteranDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./VeteranDetail.vue?vue&type=style&index=1&id=6558d082&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6558d082",
  null
  
)

export default component.exports